export default "__VITE_ASSET__BKyU0diH__"